var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('router-view',{staticStyle:{"margin-top":"105px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }